import Service from './Service';

export default class TeamService extends Service{
    constructor() {
        super();
        this.baseURL = 'team';
    }

}